<div class="searchbar-whereapp">

</div>

<mat-progress-bar mode="indeterminate" style="position: absolute; top: 68px; z-index: 27;" [hidden]="!this.loading">
</mat-progress-bar>

<div id="main-container">

    <mat-card class="example-card">
        <mat-card-header>
          <div mat-card-avatar class="example-header-image"></div>
          <mat-card-title>App24</mat-card-title>
          <mat-card-subtitle>Portale invio messaggi<br>
            (Versione {{version}})</mat-card-subtitle>
        </mat-card-header>
        <!-- <img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu"> -->
        <mat-card-content>
            <p>Vuoi consultare il manuale <a href="assets/App24PA - Manuale Portale Operatori_v.4.0.1.pdf" target="_blank">pdf</a></p>
            <p>Se hai problemi contattaci qui <a href="mailto:info@app24pa.it">info@app24pa.it</a></p>
        </mat-card-content>
        <!-- <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions> -->
      </mat-card>



</div>
